var React = require('react');

function CardsInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cards.inline"),React.createElement("g",{"id":"fda8acb6-fd50-4813-bd03-fb6b9c898d4a","data-name":"Layer 2","key":1},React.createElement("g",{"id":"f092cd46-b78b-46c6-8bec-623feadd8304","data-name":"Layer 1"},React.createElement("g",{"id":"b4c4afc5-227f-46f4-a772-0456c6e86866","data-name":"cards.inline"},React.createElement("path",{"d":"M29.82,9.82V33.65a4.19,4.19,0,0,1-4.18,4.17H9.82M26.65,6.65V30.48a4.19,4.19,0,0,1-4.17,4.18H6.65m5.5-13.18-4-5.33,4-5.34,4,5.34Zm6.67,7.34-2-2.67,2-2.67,2,2.67ZM5.48,8.81l-2-2.67,2-2.66,2,2.66Zm18,20a2.67,2.67,0,0,1-2.66,2.67H3.48A2.68,2.68,0,0,1,.81,28.82V3.48A2.68,2.68,0,0,1,3.48.81H20.82a2.67,2.67,0,0,1,2.66,2.67Z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

CardsInline.defaultProps = {"viewBox":"0 0 30.63 38.63"};

module.exports = CardsInline;

CardsInline.default = CardsInline;
